import {
  group,
  query,
  style,
  animate,
  transition,
  AnimationMetadata,
  AnimationTransitionMetadata,
} from '@angular/animations';
import { styleVariables } from '../styles/variables';

export const pgTransitionContentSwitch = [
  transition('* => *', [
    group([
      query(
        ':leave',
        style({
          position: 'relative',
          transform: 'translateY(-16px)',
          opacity: 1,
        }),
        { optional: true }
      ),
      query(
        ':enter',
        style({
          position: 'relative',
          transform: 'translateY(16px)',
          opacity: 0,
        }),
        { optional: true }
      ),
      query(
        ':leave',
        animate(
          `${styleVariables.transitionDurationShort}ms ${styleVariables.transitionCurveAcceleration}`,
          style({
            transform: 'translateY(-32px)',
            opacity: 0,
          })
        ),
        { optional: true }
      ),
      query(
        ':enter',
        animate(
          `${styleVariables.transitionDurationShort}ms ${styleVariables.transitionDurationShort}ms ${styleVariables.transitionCurveDeceleration}`,
          style({
            transform: 'translateY(0)',
            opacity: 1,
          })
        ),
        { optional: true }
      ),
    ]),
  ]),
];
